import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-food-order',
  templateUrl: './food-order.component.html',
  styleUrls: ['./food-order.component.scss']
})
export class FoodOrderComponent implements OnInit {
  ngOnInit() {
  
  }
  constructor() { }


  increment(item){
    item.count += 1;
    if(item.count == 10)
    {
      item.count =0;
    }

  }
  
  decrement(item){
   
    item.count -= 1;
    if(item.count == 0)
    {
      item.count=10;
    }

  }

  mydata = [
    {'item':1,"name":'Tea',"icon":'assets/img/pantry/tea.png',count: 0},
    {'item':2,"name":'Coffee',"icon":'assets/img/pantry/coffee.png',count: 0},
    {'item':3,"name":'Salty',"icon":'assets/img/pantry/salty.png',count: 0},
    {'item':4,"name":'Biscut',"icon":'assets/img/pantry/biscut.png',count: 0}
  ]


}


